import { render, staticRenderFns } from "./WordSeparatorForm.vue?vue&type=template&id=18838552&scoped=true&"
import script from "./WordSeparatorForm.vue?vue&type=script&lang=js&"
export * from "./WordSeparatorForm.vue?vue&type=script&lang=js&"
import style0 from "./WordSeparatorForm.vue?vue&type=style&index=0&id=18838552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18838552",
  null
  
)

export default component.exports